import { useState } from "react";
import { Dropdown, ButtonGroup } from "react-bootstrap";

const InteresadoDropdown = ({ interesados = [], task = {}, editTask, cerrado }) => {
    const [interesadoId, setInteresadoId] = useState(task?.interesadoId || "");
    const [interesadoName, setInteresadoName] = useState(
        interesados.find(i => String(i.id) === String(task?.interesadoId))?.nombre_interesado || ""
    );

    const handleSelect = (value) => {
        if (cerrado) return;
        const [id, name] = value.split("|");
        setInteresadoId(id);
        setInteresadoName(name);

        // 🔹 Actualizar en Redux o estado padre
        if (editTask) {
            editTask({
                ...task,
                interesadoId: id,
            });
        }
    };

    return (
        <Dropdown as={ButtonGroup} onSelect={cerrado ? null : handleSelect}>
            <Dropdown.Toggle variant="outline-primary" size="sm" disabled={cerrado}>
                {interesadoName ? `Interesado: ${interesadoName}` : "Agregar Interesado"}
            </Dropdown.Toggle>

            <Dropdown.Menu>
                {interesados.length === 0 ? (
                    <Dropdown.Item disabled>No hay interesados</Dropdown.Item>
                ) : (
                    interesados.map((item) => (
                        <Dropdown.Item
                            key={item.id}
                            disabled={cerrado}
                            eventKey={`${item.id}|${item.nombre_interesado}`}
                        >
                            {item.nombre_interesado}
                        </Dropdown.Item>
                    ))
                )}
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default InteresadoDropdown;
